import { get, post, patch } from 'api/requests';
import { urlChatBotPibox } from 'api';
import { message } from 'context/commons/actions';
import handleErrorMessage from 'utils/handleErrorMessage';

import { LIST_CHATBOT_OPTIONS, LIST_CHATBOT_OPTIONS_LOADING } from './constants';

// 1. Mantener esto
export const listChatbotOptions = async (dispatch, params = {}) => {
  dispatch({
    type: LIST_CHATBOT_OPTIONS_LOADING,
    loadingChatbotOptions: true,
  });

  await get(`${urlChatBotPibox}/options`, { ...params })
    .then(({ data }) => {
      dispatch({
        type: LIST_CHATBOT_OPTIONS,
        options: data,
      });
      dispatch({
        type: LIST_CHATBOT_OPTIONS_LOADING,
        loadingChatbotOptions: false,
      });
    })
    .catch((error) => {
      const mssg = handleErrorMessage(error, dispatch);
      message(dispatch, mssg);
      dispatch({
        type: LIST_CHATBOT_OPTIONS_LOADING,
        loadingChatbotOptions: false,
      });
    });
};

// 2. Función dinámica para cualquier acción interactiva
export const runChatbotAction = async (dispatch, actionKey, message) => {
    if (!actionKey || !actionKey.method || !actionKey.endpoint) {
      return null;
    }
  
    // Composición correcta de la URL final
    let url = `${urlChatBotPibox}/${actionKey.endpoint}`;
  
    // Reemplazamos :id si aplica
    if (url.includes(':id')) {
      url = url.replace(':id', message);
    }
  
    try {
      let response = null;
  
      if (actionKey.method === 'GET') {
        const { data } = await get(url);
        response = data;
      } else if (actionKey.method === 'POST') {
        const { data } = await post(url, { message });
        response = data;
      } else if (actionKey.method === 'PATCH') {
        const { data } = await patch(url, { message });
        response = data;
      }
  
      return response;
    } catch (error) {
      return {error: true, message: handleErrorMessage(error, dispatch)};
    }
  };

  export const isChatbotEnabled = async () => {
    try {
      const { data } = await get(`${urlChatBotPibox}/availability`);
      return data.enabled;
    } catch (error) {
      console.error('Error consultando disponibilidad del chatbot:', error);
      return false;
    }
  };
  